import React from 'react'
import { Block, Typography } from '@xprog/prensa'
import { BylineProps } from './Byline.types'
import get from 'lodash/get'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'

const Byline = (props: BylineProps) => {
  const RenderImage = props?.componentImage
  const authorImgSrc = get(props, 'authorImage.imageProps.src', false)
  const customCssContent: PrensaEngineCSSProp = !props?.showListenButton ? {
    ...props?.customCssContent,
    '@lg': {
      align: ['column', 'left', 'top'],
      '> p': {
        pr: '$2'
      }
    }
  } : props?.customCssContent as PrensaEngineCSSProp

  const publishedDate = props.publishedDate?.original
  const modifiedDate = props.modifiedDate?.original

  const isoDatePublished = typeof publishedDate === 'number' ? new Date(publishedDate).toISOString() : ''
  const isoDateModified = typeof modifiedDate === 'number' ? new Date(modifiedDate).toISOString() : ''

  return (
    <Block css={props?.customCss}>
      <Block css={props?.customCssLeft}>
        {props.authorImage?.enabled && authorImgSrc && RenderImage && (
          <RenderImage {...props.authorImage?.imageProps} />
        )}
        <Block css={customCssContent}>
          <Typography
            className='autor-opopular' 
            itemProp='author'
            as={props.author?.as}
            css={props.author?.customCss}
            variant={props.author?.variant}
          >
            {props.author?.value}
          </Typography>
          {/* {props?.authorEmail?.enabled && (
            <Typography
              as={props.authorEmail.as}
              css={props.authorEmail.customCss}
              variant={props.authorEmail.variant}
            >
              {props.authorEmail.value}
            </Typography>
          )} */}
          {props?.publishedDate?.enabled && (
            <Typography
              as={props.publishedDate.as}
              css={props.publishedDate.customCss}
              variant={props.publishedDate.variant}
              itemProp='datePublished'
              dateTime={isoDatePublished}
            >
              {props.publishedDate.value}
            </Typography>
          )}
          {props?.modifiedDate?.enabled && (
            <Typography
              as={props.modifiedDate.as}
              css={props.modifiedDate.customCss}
              variant={props.modifiedDate.variant}
              itemProp='dateModified'
              dateTime={isoDateModified}
            >
              {props.modifiedDate.value}
            </Typography>
          )}
        </Block>
      </Block>
      {props?.showListenButton && (
        <Block css={props?.customCssRight}>{props.rightSlot?.children}</Block>
      )}
    </Block>
  )
}

Byline.defaultProps = {
  as: 'p',
  variant: 'default-texts-md'
}

export default Byline
